import { observable, set } from 'mobx';

export interface IProductNotifyMeConfig {
    productDisplayName: string;
    productUrl: string;
    productImageUrl: string;
    skuId: string;
    skuBaseId: string;
    subscriptionType: string;
    altText: string;
}

export class Product {
    @observable public productDisplayName: string;
    @observable public productUrl: string;
    @observable public productImageUrl: string;
    @observable public skuId: string;
    @observable public skuBaseId: string;
    @observable public subscriptionType: string;
    @observable public altText: string;

    public static FROM_JSON(data: IProductNotifyMeConfig) {
        const product = new Product();
        set(product, data);

        return product;
    }
}
